import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImage, faFilm, faRotate, faScissors, faUserAstronaut,
  faMicrophone, faClapperboard, faShirt,
} from "@fortawesome/free-solid-svg-icons";

// Icône + accroche courte par capacité — rail sombre façon Higgsfield, contenu
// dans son propre panneau (pas de changement du thème clair global du Dashboard).
const CAPABILITY_META = {
  text2image:  { icon: faImage,        blurb: "Texte → image" },
  text2video:  { icon: faFilm,         blurb: "Texte → vidéo" },
  image2video: { icon: faRotate,       blurb: "Anime une image" },
  editvideo:   { icon: faScissors,     blurb: "Retouche une vidéo" },
  avatar:      { icon: faUserAstronaut, blurb: "Portrait animé" },
  voiceover:   { icon: faMicrophone,   blurb: "Voix off IA" },
  ugc:         { icon: faClapperboard, blurb: "Témoignage UGC" },
  tryon:       { icon: faShirt,        blurb: "Essayage virtuel" },
};

const StudioSidebar = ({ capabilities, capability, onSelect }) => {
  return (
    <div className="w-full md:w-56 shrink-0 rounded-2xl bg-gradient-to-b from-[#1a1640] via-[#221C51] to-[#2e265e] p-3 shadow-lg">
      <div className="px-2 pt-1 pb-3">
        <p className="text-[11px] font-bold uppercase tracking-wider text-fuchsia-300/80">Studio</p>
        <p className="text-sm font-bold text-white">Outils de création</p>
      </div>
      <nav className="flex md:flex-col gap-1.5 overflow-x-auto md:overflow-visible pb-1 md:pb-0">
        {capabilities.map(([key, label]) => {
          const meta = CAPABILITY_META[key] || {};
          const active = capability === key;
          return (
            <button
              key={key}
              onClick={() => onSelect(key)}
              className={`group flex items-center gap-3 shrink-0 md:shrink text-left px-3 py-2.5 rounded-xl transition ${
                active
                  ? "bg-gradient-to-r from-fuchsia-600 to-indigo-600 text-white shadow-md"
                  : "text-indigo-100/80 hover:bg-white/10 hover:text-white"
              }`}
            >
              <span className={`flex items-center justify-center w-8 h-8 rounded-lg shrink-0 transition ${
                active ? "bg-white/20" : "bg-white/5 group-hover:bg-white/10"
              }`}>
                <FontAwesomeIcon icon={meta.icon || faFilm} className="text-sm" />
              </span>
              <span className="min-w-0 hidden sm:block">
                <span className="block text-sm font-semibold truncate">{label}</span>
                <span className={`block text-[11px] truncate ${active ? "text-white/70" : "text-indigo-200/50"}`}>{meta.blurb}</span>
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default StudioSidebar;
